module.exports = __webpack_public_path__ + "static/media/volume-down.1673ac04.svg";